/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// MUI
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

// Actions
import * as DrawerActions from 'store/ducks/drawer/actions';

// Type
import { ApplicationState } from 'store';

// Components
import { AppBar, Drawer } from '../index';

// Styles
import useStyles from './styles';

const Layout: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const SMALL_SCREEN = 960;

  const [clientWidth, setClientWidth] = useState(window.innerWidth);

  const visible = useSelector(
    (state: ApplicationState) => state.layout.visible,
  );

  const drawerOpen = useSelector(
    (state: ApplicationState) => state.drawer.open,
  );

  useEffect(() => {
    const handleResize = () => setClientWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return visible ? (
    <>
      <AppBar clientWidth={clientWidth} />
      {clientWidth < SMALL_SCREEN ? (
        <SwipeableDrawer
          className={classes.background}
          anchor='left'
          open={drawerOpen}
          onClose={() =>
            dispatch(
              DrawerActions.setToggleDrawer({
                open: false,
              }),
            )
          }
          onOpen={() =>
            dispatch(
              DrawerActions.setToggleDrawer({
                open: true,
              }),
            )
          }>
          <Drawer />
        </SwipeableDrawer>
      ) : (
        <Drawer />
      )}
    </>
  ) : (
    <></>
  );
};

export default Layout;
export { Layout };
